export default __webpack_public_path__ + "static/media/cto-min.ae6ccc58.png";